import browser from 'Cloud/browser';
import { name } from 'reactApp/modules/aiTools/helpers/constants';
import { sendDwhRadar } from 'reactApp/modules/dwh/dwh.helpers';
import type { Actions } from 'reactApp/modules/dwh/dwh.types';

const dwh_enabled_fields = [['ua', 'error', 'gpuPresent', 'gpuUsed', 'name']];

export const sendErrorRadar = (action: string, error = 'unk', gpuPresent = 'u', gpuUsed = 'u') => {
    const data = {
        ua: `${browser.getBrowserName()}_${browser.getOsFamily()}`,
        error,
        gpuPresent,
        gpuUsed,
        name,
    };
    sendDwhRadar({ t: 'err', action: action as Actions, dwh_enabled: true, dwh_enabled_fields, name, data });
};
